import { render, staticRenderFns } from "./HouseType.vue?vue&type=template&id=b549a326&scoped=true&"
import script from "./HouseType.vue?vue&type=script&lang=js&"
export * from "./HouseType.vue?vue&type=script&lang=js&"
import style0 from "./HouseType.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HouseType.vue?vue&type=style&index=1&id=b549a326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b549a326",
  null
  
)

export default component.exports